import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

export const pct = (v, digits = 1) => (v === null || v === undefined ? '—' : `${v > 0 ? '+' : ''}${Number(v).toFixed(digits)}%`);
const pnlCls = (v) => (v === null || v === undefined ? 'text-slate-500' : v > 0 ? 'text-emerald-300' : v < 0 ? 'text-rose-300' : 'text-slate-300');
const rateCls = (r) => (r === null || r === undefined ? 'text-slate-500' : r >= 60 ? 'text-emerald-300' : r >= 40 ? 'text-amber-300' : 'text-rose-300');

const fmtTime = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    return d.toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
};

export const outcomeMeta = (e) => {
    if (e.status !== 'closed') return { label: 'İZLENİYOR', cls: 'bg-sky-500/15 text-sky-200 border-sky-500/40' };
    if (e.outcome === 'REALIZED') return { label: 'TUTTU', cls: 'bg-emerald-500/20 text-emerald-200 border-emerald-500/50' };
    if (e.outcome_reason === 'expired') return { label: 'TUTMADI · 24s doldu', cls: 'bg-slate-700/60 text-slate-300 border-slate-600' };
    return { label: 'TUTMADI · ters %3', cls: 'bg-rose-500/15 text-rose-200 border-rose-500/40' };
};

const Dir = ({ d }) =>
    d === 'long' ? <ArrowUpRight className="h-3.5 w-3.5 text-emerald-400 inline" /> : <ArrowDownRight className="h-3.5 w-3.5 text-rose-400 inline" />;

export const RateCell = ({ s }) => (
    <span className="font-mono">
        <b className={rateCls(s.rate_pct)}>{s.n ? `${s.realized}/${s.n}` : '—'}</b>
        {s.rate_pct !== null && s.rate_pct !== undefined && <span className="text-slate-500"> (%{s.rate_pct})</span>}
    </span>
);

export const CoinTable = ({ rows, onPick, active }) => (
    <div className="overflow-auto max-h-80 pr-1" data-testid="radar-history-coin-table">
        <table className="w-full text-[11px]">
            <thead className="sticky top-0 bg-slate-800">
                <tr className="text-[10px] uppercase tracking-wider text-slate-400 border-b border-slate-700">
                    <th className="text-left py-1.5 pr-2 font-medium">Coin</th>
                    <th className="text-left py-1.5 px-2 font-medium">Tuttu</th>
                    <th className="text-right py-1.5 px-2 font-medium">Ort. en iyi</th>
                    <th className="text-right py-1.5 px-2 font-medium">Kaldıraçlı ort.</th>
                    <th className="text-right py-1.5 px-2 font-medium">L/S</th>
                    <th className="text-right py-1.5 pl-2 font-medium">Açık</th>
                </tr>
            </thead>
            <tbody>
                {rows.map((r) => (
                    <tr
                        key={r.symbol}
                        data-testid={`radar-history-coin-${r.symbol}`}
                        onClick={() => onPick(r.symbol)}
                        className={`border-b border-slate-800 cursor-pointer hover:bg-slate-700/40 transition-colors ${active === r.symbol ? 'bg-sky-500/10' : ''}`}
                    >
                        <td className="py-1.5 pr-2 font-mono font-semibold text-slate-100">{r.symbol.replace('USDT', '')}</td>
                        <td className="py-1.5 px-2"><RateCell s={r} /></td>
                        <td className="py-1.5 px-2 text-right font-mono text-slate-200">{pct(r.avg_mfe_pct, 2)}</td>
                        <td className={`py-1.5 px-2 text-right font-mono ${pnlCls(r.avg_lev_pnl_pct)}`}>{pct(r.avg_lev_pnl_pct)}</td>
                        <td className="py-1.5 px-2 text-right font-mono text-slate-400">{r.long}/{r.short}</td>
                        <td className="py-1.5 pl-2 text-right font-mono text-sky-300">{r.open || ''}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export const Bar = ({ label, s, testid }) => (
    <div data-testid={testid} className="space-y-0.5">
        <div className="flex items-center justify-between text-[10px]">
            <span className="text-slate-300 truncate pr-2">{label}</span>
            <RateCell s={s} />
        </div>
        <div className="h-1.5 rounded-sm bg-slate-700 overflow-hidden">
            <div className={`h-full ${s.rate_pct >= 60 ? 'bg-emerald-400' : s.rate_pct >= 40 ? 'bg-amber-400' : 'bg-rose-400'}`} style={{ width: `${s.n ? s.rate_pct : 0}%` }} />
        </div>
    </div>
);

export const RecentList = ({ items }) => (
    <ul className="divide-y divide-slate-800 max-h-72 overflow-y-auto pr-1" data-testid="radar-history-recent">
        {items.map((e) => {
            const m = outcomeMeta(e);
            return (
                <li key={e.id} data-testid={`radar-history-event-${e.id}`} className="py-1.5 flex items-center gap-2 text-[11px] flex-wrap">
                    <Dir d={e.direction} />
                    <span className="font-mono font-semibold text-slate-100 w-14">{e.symbol.replace('USDT', '')}</span>
                    <span className="text-[9px] uppercase text-slate-400 w-16">{e.stage === 'AC' ? 'POZ. AÇ' : 'HAZIRLAN'} {e.passed_count}/7</span>
                    <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded-sm border ${m.cls}`}>{m.label}</span>
                    <span className="text-slate-400">en iyi <b className="font-mono text-slate-200">{pct(e.max_favorable_pct, 2)}</b></span>
                    {e.lev_pnl_pct !== null && (
                        <span className="text-slate-400">
                            {e.leverage ? `${e.leverage}x` : '1x'} → <b className={`font-mono ${pnlCls(e.lev_pnl_pct)}`}>{pct(e.lev_pnl_pct)}</b>
                        </span>
                    )}
                    <span className="ml-auto text-[10px] text-slate-500 font-mono">{fmtTime(e.created_at)}</span>
                </li>
            );
        })}
    </ul>
);
